var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"content-section"},[_c('h2',{staticClass:"section-header",attrs:{"id":_vm.section.name}},[_vm._v(_vm._s(_vm.section.name))]),_c('div',{staticClass:"shop-items"},_vm._l((_vm.section.items.slice()),function(item){return _c('storeitem',{key:item.ID,attrs:{"item":item,"section-name":_vm.section.name}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }